import permissionService from '../../api/permission'
const state = {
  permissions: [],
  modules: []
}

const mutations = {
  setPermissions (state, permissions) {
    state.permissions = permissions
  },
  setModules (state, modules) {
    state.modules = modules
  }
}

const actions = {
  getPermissions ({ commit }) {
    permissionService.getPermissions().then(response => {
      commit('setPermissions', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  createPermission ({ commit }, permission) {
    return new Promise((resolve, reject) => {
      permissionService.createPermission(permission).then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getModules ({ commit }) {
    permissionService.getModules().then(response => {
      commit('setModules', response.data)
    }).catch(error => {
      console.log(error)
    })
  }
}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
